import * as React from 'react';

function NoGuestIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.97 22.03 2.47 3.53l1.06-1.06 18.5 18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.827 3.311v4.052l-1.516.002V3.508H10.69v3.857l-1.516-.002V3.311A1.316 1.316 0 0 1 10.493 2h3.014a1.316 1.316 0 0 1 1.32 1.311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.827 7.363h1.24a1.98 1.98 0 0 1 1.985 1.976v9.774l-1.513-1.515V9.339a.47.47 0 0 0-.471-.469H7.932a.5.5 0 0 0-.102.012L6.714 7.78a1.98 1.98 0 0 1 1.218-.417h1.24l1.517.002h2.622zM5.948 19.162V9.34q0-.095.01-.188L7.46 10.65v8.513a.47.47 0 0 0 .471.469h8.136a.47.47 0 0 0 .286-.096l1.069 1.07a1.98 1.98 0 0 1-1.355.532h-.236a.886.886 0 0 1-1.77 0H9.927a.886.886 0 0 1-1.771 0h-.225a1.98 1.98 0 0 1-1.984-1.976"
  }));
}

export { NoGuestIcon };
